import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AiService {
  private apiUrl = 'https://api.openai.com/v1/chat/completions';
  private apiKey = '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'; // Remplace par ta clé API

  constructor(private http: HttpClient) {}

  getSuggestions(message: string, context: string[]): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.apiKey}`,
    });

    const messages = context.map((msg) => ({ role: 'user', content: msg }));
    messages.push({ role: 'user', content: message });
    messages.push({ role: 'system', content: "Réponds avec des options comme : 'Je t'enverrai plus tard', 'Désolé, je ne l'ai pas', ou 'Avec plaisir, voici le lien.'" });

    const body = {
      model: 'gpt-3.5-turbo',
      messages: messages,
    };

    return this.http.post(this.apiUrl, body, { headers });
  }
}
